import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center justify-between">
          <div className="rounded-lg bg-slate-900 p-3" style={{ width: "fit-content" }}>
            <img src="/logo.webp" alt="The Retrofitter" className="h-8 w-auto" />
          </div>
          <LanguageSwitcher triggerClassName="border-slate-300 bg-white text-slate-700" />
        </div>
        <h2 className="font-heading text-2xl font-extrabold text-slate-900">{t("auth.resetPassword")}</h2>
        {done ? (
          <div data-testid="forgot-done" className="mt-4 rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-700">
            {t("auth.forgotDone")}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="overline text-slate-500">{t("auth.email")}</Label>
              <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-12 border-slate-300 bg-white" />
            </div>
            {error && <div className="text-sm text-red-600">{error}</div>}
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="h-12 w-full bg-blue-600 hover:bg-blue-500">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : t("auth.sendResetLink")}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-center text-sm text-blue-600 hover:underline">{t("auth.backToSignIn")}</Link>
      </div>
    </div>
  );
}
